export function getObjects(obj, key, val) {
  var objects = [];
  for (var i in obj) {
    if (!obj.hasOwnProperty(i)) continue;
    if (typeof obj[i] == "object") {
      objects = objects.concat(getObjects(obj[i], key, val));
    }
    //if key matches and value matches or if key matches and value is not passed (eliminating the case where key matches but passed value does not)
    else if ((i === key && obj[i] === val) || (i === key && val === "")) {
      //
      objects.push(obj);
    } else if (obj[i] === val && key === "") {
      if (objects.lastIndexOf(obj) === -1) {
        objects.push(obj);
      }
    }
  }
  return objects;
}

// export function sortObject(obj, triOrder = "asc") {
//   if (triOrder === "desc") {
//     return Object.keys(obj)
//       .sort()
//       .reverse()
//       .reduce((res, key) => ((res[key] = obj[key]), res), {});
//   }

//   return Object.keys(obj)
//     .sort()
//     .reduce((res, key) => ((res[key] = obj[key]), res), {});
// }
